import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from './menu-item.interface';

@Component({
  selector: 'app-menu',
  template: `
    <ion-list lines="none" class="ion-no-padding">
      <div *ngFor="let item of menu; let i = index">
        <div *ngIf="item.menu?.length; else menuItem">
          <app-menu-submenu [item]="item" (onItemClick)="onItemClick($event)"></app-menu-submenu>
        </div>
        <ng-template #menuItem>
          <app-menu-item [item]="item" (onItemClick)="onItemClick($event)"></app-menu-item>
        </ng-template>
      </div>
    </ion-list>
  `,
  styles: [],
})
export class MenuComponent {

  @Input() menu = [];
  @Output() onClickItem = new EventEmitter();

  constructor(private router: Router) { }

  onItemClick(ev: { ev: Event, item: MenuItem }) {
    if (ev.item.fnc) {
      ev.item.fnc()
      return
    }
    if (ev.item.url) this.router.navigate([ev.item.url])
  }

}
